import {
  Button,
  Container,
  Nav,
  Navbar,
  NavDropdown,
  Offcanvas,
} from "react-bootstrap";
import "./MainNavbar.css";
import { IoIosArrowDown, IoIosMailUnread } from "react-icons/io";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/img/logo.png";
import { FaPhoneAlt, FaRegUserCircle } from "react-icons/fa";

export default function MainNavbar() {
  const [hoveredDropdown, setHoveredDropdown] = useState(null);
  const handleMouseEnter = (id) => {
    if (window.innerWidth >= 992) {
      setHoveredDropdown(id);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth >= 992) {
      setHoveredDropdown(null);
    }
  };
  const handleLogOut = (e) => {
    e.preventDefault();
    localStorage.setItem("isAdmin", JSON.stringify("false"));
    window.location.href = "/admin/login  ";
  };
  useEffect(() => {
    console.log(localStorage.getItem("isAdmin"));
  }, []);

  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const handleClose = () => setShowOffcanvas(false);
  const handleShow = () => setShowOffcanvas(true);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // 50px threshold
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      <Navbar
        expand="lg"
        className={`${
          window.location.pathname == "/" ? "home-nav" : ""
        } main-navbar section-spacing-x ${
          isScrolled ? "scrolled shadow-sm" : ""
        }`}
      >
        <Container fluid>
          <Navbar.Brand as={Link} to="/">
            <img
              src={logo}
              className="img-fluid"
              alt="Indian Diamond Insitute | Passion: Technology: Innovation | Sreehari Diamond Laboratory "
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls={`offcanvasNavbar-expand-lg`}
            onClick={handleShow}
          />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-lg`}
            aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
            placement="end"
            show={showOffcanvas}
            onHide={handleClose}
          >
            <Offcanvas.Header closeButton className="offcanvas-header">
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
                <img
                  src={logo}
                  className="img-fluid"
                  alt="shreeharidiamondlab"
                />
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="navbar-links justify-content-end flex-grow-1 ">
                <Link to="/" className="nav-link" onClick={handleClose}>
                  Home
                </Link>
                <Link
                  to="/about-us"
                  className="nav-link mx-lg-2"
                  onClick={handleClose}
                >
                  About Us
                </Link>
                <NavDropdown
                  className=""
                  data-toggle="dropdown"
                  title={
                    <Link
                      to="/services"
                      className=""
                      role="button"
                      onClick={handleClose}
                    >
                      Services
                    </Link>
                  }
                  id="offcanvasNavbarDropdown-expand-sm"
                  renderMenuOnMount={true}
                >
                  <NavDropdown.Item
                    as={Link}
                    onClick={handleClose}
                    to="/diamond-sealing-service"
                  >
                    Diamond Sealing Service
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    onClick={handleClose}
                    to="/online-certificate-verification"
                  >
                    Online Certificate Verification
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    onClick={handleClose}
                    to="/diamond-hologram-stickers"
                  >
                    Hologram Security Stickers
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown
                  className=""
                  data-toggle="dropdown"
                  title={
                    <Link
                      to="/certificates"
                      className=""
                      role="button"
                      onClick={handleClose}
                    >
                      Certificates
                    </Link>
                  }
                  id="offcanvasNavbarDropdown-expand-sm"
                  renderMenuOnMount={true}
                >
                  <NavDropdown.Item
                    as={Link}
                    onClick={handleClose}
                    to="/full-diamond-grading-reports"
                  >
                    Full Diamond Grading Reports
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    onClick={handleClose}
                    to="/diamond-jewelry-reports"
                  >
                    Diamond Jewelry Reports
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    onClick={handleClose}
                    to="/fancy-diamond-reports"
                  >
                    Fancy Diamond Reports
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    as={Link}
                    onClick={handleClose}
                    to="/lab-grown-reports"
                  >
                    Lab Grown Reports
                  </NavDropdown.Item>
                </NavDropdown>

                {/* <NavDropdown
                  title={
                    <>
                      Services <IoIosArrowDown />
                    </>
                  }
                  id={`offcanvasNavbarDropdown-expand-lg`}
                  show={hoveredDropdown === "dropdown"}
                  onMouseEnter={() => handleMouseEnter("dropdown")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavDropdown.Item as={Link} to="/diamond-sealing-service">
                    Sealing Service
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/online-certificate-verification">
                    Online Service
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/diamond-hologram-stickers">
                    Hologram Security
                  </NavDropdown.Item>
                </NavDropdown> */}
                <Link
                  to="/research"
                  className="nav-link mx-lg-2"
                  onClick={handleClose}
                >
                  Research
                </Link>
                <Link
                  to="/our-store"
                  className="nav-link mx-lg-2"
                  onClick={handleClose}
                >
                  Our Store
                </Link>

                <Link
                  to="/4cs-of-diamonds"
                  className="nav-link mx-lg-2"
                  onClick={handleClose}
                >
                  4Cs Education
                </Link>
                {/* <Link
                  to="/certificates"
                  className="nav-link mx-lg-2"
                  onClick={handleClose}
                >
                  Our Store
                </Link> */}
                <Link
                  to="/contact-us"
                  className="nav-link mx-lg-2"
                  onClick={handleClose}
                >
                  Contact Us
                </Link>

                <ul className="list-unstyled d-flex flex-column justify-content-start gap-3 mb-0 d-lg-none mt-3">
                  <li>
                    <a
                      href="tel:+919443736692"
                      className="d-flex align-items-center gap-2"
                    >
                      <span>
                        <FaPhoneAlt />
                      </span>
                      <span>+91 94437 36692</span>
                    </a>
                  </li>
                  <li className="my-2">
                    <a
                      href="tel:+919442101562"
                      className="d-flex align-items-center gap-2"
                    >
                      <span>
                        <FaPhoneAlt />
                      </span>
                      <span>+91 94421 01562</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="mailto:sreeharidiamondlab@gmail.com"
                      className="d-flex align-items-center gap-2 mail"
                    >
                      <span>
                        <IoIosMailUnread />
                      </span>
                      <span>sreeharidiamondlab@gmail.com </span>
                    </a>
                  </li>
                </ul>
                {/* <NavDropdown
                  title={
                    <>
                      <span className="userprofilebtn ">
                        <FaRegUserCircle />
                      </span>
                    </>
                  }
                  id={`profiledropdown`}
                  className="userdropmenu menudropdown d-none d-lg-flex align-items-center ms-2"
                  show={hoveredDropdown === "profiledropdown"}
                  onMouseEnter={() => handleMouseEnter("profiledropdown")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavDropdown.Item href="#action3">Profile</NavDropdown.Item>
                  <NavDropdown.Item onClick={handleLogOut}>
                    Log Out
                  </NavDropdown.Item>
                </NavDropdown>
                <Button
                  variant="light"
                  onClick={handleLogOut}
                  className="w-100 offcan-logout-btn d-lg-none"
                >
                  Log Out
                </Button> */}
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </>
  );
}
